import { render, staticRenderFns } from "./PrintQRHeavy.vue?vue&type=template&id=e5d4356a"
import script from "./PrintQRHeavy.vue?vue&type=script&lang=js"
export * from "./PrintQRHeavy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports